export default class DtoEvent {
    constructor(obj) {
        this.id = obj.number
        this.code = obj.code
        this.number = obj.number
        this.eventType = obj.eventType
        this.date = obj.date
        this.volt = obj.volt
        this.comment = obj.comment
        this.chgtpiles = obj.chgtpiles
        this.graph = obj.graph
        this.bankExport = obj.bankExport
        this.problem = obj.problem
        this.solution = obj.solution
        this.eventHour = obj.eventHour
        this.eventMinutes = obj.eventMinutes
        this.razstation = obj.razstation
        this.valeurcalee = obj.valeurcalee
        this.sondeTemperature = obj.sondeTemperature
        this.centralTemperature = obj.centralTemperature
        this.contactCode = obj.contactCode
        this.ns = obj.ns
        this.nc = obj.nc
        this.closeDate = obj.closeDate
        this.action = obj.action
        this.stationType = obj.stationType
        this.stationCode = obj.stationCode
        this.stationId = obj.stationId || obj.code
        this.updateLogin = obj.updateLogin
        this.updateDate = obj.updateDate
        this.monitoring = obj.monitoring
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.downloadData = obj.downloadData
        this.transmissionPowerSupplyUpdate = obj.transmissionPowerSupplyUpdate
        this.transmissionTest = obj.transmissionTest
        this.calibrationUpdate = obj.calibrationUpdate
        this.sensorPowerSupplyUpdate = obj.sensorPowerSupplyUpdate
        this.replacement = obj.transmissionPowerSupplyReplacementDate
        this.sensorVoltage = obj.sensorVoltage
        this.sensorPowerSupplyReplacementDate = obj.sensorPowerSupplyReplacementDate
        this.replaceDesiccant = obj.replaceDesiccant
        this.replaceORings = obj.replaceORings
        this.firmwareUpdate = obj.firmwareUpdate
        this.campaignCode = obj.campaignCode
        this.causeNonRealisation = obj.causeNonRealisation
        this.controls = obj.controls || []
    }
}
